import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { User, ChangePassword } from '@app/core';
import * as fromStore from '@app/core/store';
import { Store } from '@ngrx/store';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.scss']
})
export class ProfileViewComponent implements OnInit {
  user$ = this.store.select(fromStore.selectLoggedInUser);
  constructor(private store: Store<fromStore.State>, private formBuilder: FormBuilder) { }
  passwordForm: FormGroup;

  ngOnInit() {
    this.passwordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      passwords: this.formBuilder.group({
        password: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
      }, { validator: this.matchPassword })
    });
  }

  matchPassword(group: FormGroup)  {
    let password = group.controls['password'].value;
    let confirmPassword = group.controls['confirmPassword'].value;
    if (password != confirmPassword) {
      return { matchPassword: true };
    } else {
      return null;
    }
  }


  onSubmit(user: User) {
    this.store.dispatch(new fromStore.ProfileActions.UpdateProfile(user))
  }

  onUpdatePassword() {
    this.store.dispatch(new fromStore.ProfileActions.ChangePassword({
      oldPassword: this.passwordForm.value.oldPassword,
      newPassword: this.passwordForm.value.passwords.password}))
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/profile-view/profile-view.component.ts